import { createContext, useContext } from 'react';

interface IBottomSheetContext {
  openSheet: (sheetIndex: number) => void;
  closeSheet: () => void;
  setActiveSheet: (index: number) => void;
}

export const BottomSheetContext = createContext<IBottomSheetContext | undefined>(undefined);

const useCustomBottomSheet = () => {
  const context = useContext(BottomSheetContext);

  if (context === undefined) {
    throw new Error('useBottomSheet должен использоваться внутри BottomSheetProvider');
  }

  return context;
};

export default useCustomBottomSheet;
